import { Tooltip } from "@gigpro/ui/Tooltip";
import type React from "react";

type CompletionRateProps = {
  /**
   * Completion rate as a fraction
   *
   * Ex.: 0.79 is a completion rate of 79%
   */
  completionRate?: number | null;
};

export const ProCompletionRate: React.FC<CompletionRateProps> = ({ completionRate }) => (
  <Tooltip
    side="right"
    content="This percentage represents the number of confirmed shifts that a Pro has worked as opposed to calling out or not showing up."
  >
    <p className="w-fit text-nowrap">
      Completion Rate
      <strong className="ml-1">{((completionRate ?? 0) * 100).toFixed(0)}%</strong>
    </p>
  </Tooltip>
);
